export const ACCEPTED_MEDIA_FILE_TYPES = [
  { mimeType: "image/jpeg", extensions: [".jpg", ".jpeg"] },
  { mimeType: "image/png", extensions: [".png"] },
  { mimeType: "image/gif", extensions: [".gif"] },
  { mimeType: "image/webp", extensions: [".webp"] },
  { mimeType: "image/heic", extensions: [".heic"] },
  { mimeType: "image/heif", extensions: [".heif"] },
  { mimeType: "image/bmp", extensions: [".bmp"] },
  { mimeType: "image/tiff", extensions: [".tif", ".tiff"] },
  { mimeType: "video/mp4", extensions: [".mp4"] },
  { mimeType: "video/quicktime", extensions: [".mov"] },
  { mimeType: "video/x-msvideo", extensions: [".avi"] },
  { mimeType: "video/webm", extensions: [".webm"] },
  { mimeType: "application/pdf", extensions: [".pdf"] },
] as const;

export type AcceptedFileTypeMap = {
  "image/*": string[];
  "video/*": string[];
  "application/pdf": string[];
};

const extensionsWithMimePrefix = (prefix: string) =>
  ACCEPTED_MEDIA_FILE_TYPES.filter(({ mimeType }) =>
    mimeType.startsWith(prefix)
  ).flatMap(({ extensions }) => [...extensions]);

export const DROPZONE_ACCEPTED_FILE_TYPES: AcceptedFileTypeMap = {
  "image/*": extensionsWithMimePrefix("image/"),
  "video/*": extensionsWithMimePrefix("video/"),
  "application/pdf": extensionsWithMimePrefix("application/pdf"),
};

export const ACCEPTED_MIME_TYPES = ACCEPTED_MEDIA_FILE_TYPES.map(
  ({ mimeType }) => mimeType
).join(",");
